import { PageService, ProductService } from '@core/services/steelfab';
import { Component } from '@rhtml/component';
import { AngularLayout } from '@rhtml/modifiers';
import { Inject } from '@rxdi/core';
import { html, LitElement } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * @customElement app-component
 */
@Component({
  Settings: {
    selector: 'app-component',
    modifiers: [...AngularLayout],
  },
  State(this: AppComponent) {
    return this.state;
  },
  Render: () =>
    function (this, state) {
      return html`
        <router-outlet>
          <navbar-component ngIf=${!state.includes('/admin')} slot="header"></navbar-component>

          <site-footer-component slot="footer"></site-footer-component>
        </router-outlet>
      `;
    },
})
export class AppComponent extends LitElement {
  @Router()
  router: Router;

  state = new BehaviorSubject(location.href);

  @Inject(ProductService)
  productService: ProductService;

  @Inject(PageService)
  pageService: PageService;

  $destroy = new Subject();

  OnInit() {
    combineLatest([this.productService.getProducts(), this.pageService.getPageById('home-hero')]).subscribe();
  }

  OnRendererLoaded() {
    this.router
      .onSnapshotChange()
      .pipe(takeUntil(this.$destroy))
      .subscribe((path: CustomEvent<{ location: Location }>) => {
        this.state.next(path.detail.location.pathname);
      });
  }

  OnDestroy() {
    this.$destroy.next(true);
  }
}
